import { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Practice Areas", href: "#target-locations" },
  { label: "ICAI Credentials", href: "#icai-compliance" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-40 backdrop-blur-md bg-paper/90 border-b border-slate-200/80" data-testid="site-navbar">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[76px] flex items-center justify-between">
        <Logo />
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-ink-soft hover:text-brass-dark transition-colors duration-300">
              {l.label}
            </a>
          ))}
          <a href="https://wa.me/919654852550?text=Hello%2C%20I%20need%20a%20Chartered%20Accountant%20in%20Ghaziabad."
            target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-cta"
            className="inline-flex items-center gap-2 rounded-full bg-ink text-paper text-sm font-semibold px-5 py-2.5 hover:bg-forest transition-colors duration-300">
            <MessageCircle size={16} /> WhatsApp
          </a>
        </div>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-paper px-6 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
              className="text-base font-medium text-ink-soft">{l.label}</a>
          ))}
          <a href="https://wa.me/919654852550" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-forest font-semibold">
            <MessageCircle size={16} /> WhatsApp Us
          </a>
        </div>
      )}
    </header>
  );
};
